import { Batch } from "../../Models/Batch";
import ActionType from "../../Models/ActionType";
import * as types from "./types";
import { AuthActionType, User } from "../../Models/Auth";
export interface AuthState {
  authenticationInProgress: boolean;
  authorizationToken?: null | string;
  user?: null | User;
}
const initialState = {
  authenticationInProgress: false,
  authorizationToken: null,
  user: null,
};

const auth = (
  state: AuthState = initialState,
  action: AuthActionType
): AuthState => {
  switch (action.type) {
    case types.AUTHENTICATE_USER:
      return {
        ...state,
        authenticationInProgress: true,
      };
    case types.AUTHENTICATE_USER_SUCCESS:
      return {
        ...state,
        authenticationInProgress: false,
        authorizationToken: action.token,
        user: action.user,
      };
    case types.AUTHENTICATE_USER_FAILURE:
      return {
        ...state,
        authenticationInProgress: false,
      };

    case types.LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default auth;
